import request from "@/utils/request";

const api = {
  GetCurrentWorkbench: "/current-workbench"

};

export function getAppCurrentWorkbench(parameter) {
  return request({
    url: api.GetCurrentWorkbench,
    method: "get",
    params: parameter,
    headers: {
      'device': 'mobile'
    }
  });
}
